import { render, staticRenderFns } from "./CustomizationSection.vue?vue&type=template&id=6f8033d1"
import script from "./CustomizationSection.vue?vue&type=script&lang=js"
export * from "./CustomizationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports